export default "__VITE_ASSET__D39qGD$0__"